module.exports = __webpack_public_path__ + "img/139.38294f65.jpg";